import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutGrid, CalendarDays, ListChecks, BarChart3, Wallet, CreditCard, Clock, Menu } from "lucide-react";

export default function MobileBottomNav({ isEmployee, showRevenue, showPnl, showPayments, onMore }) {
  const items = isEmployee
    ? [
        { to: "/dashboard/calendar", icon: CalendarDays, label: "Calendar", testid: "bottomnav-calendar" },
        { to: "/dashboard/bookings", icon: ListChecks, label: "Bookings", testid: "bottomnav-bookings" },
      ]
    : [
        { to: "/dashboard", end: true, icon: LayoutGrid, label: "Home", testid: "bottomnav-home" },
        { to: "/dashboard/calendar", icon: CalendarDays, label: "Calendar", testid: "bottomnav-calendar" },
        { to: "/dashboard/analytics", icon: BarChart3, label: "Revenue", testid: "bottomnav-analytics" },
      ];
  if (isEmployee && showRevenue) items.push({ to: "/dashboard/analytics", icon: BarChart3, label: "Revenue", testid: "bottomnav-analytics" });
  if (showPnl) items.push({ to: "/dashboard/profit-loss", icon: Wallet, label: "P&L", testid: "bottomnav-pnl" });
  if (showPayments) items.push({ to: "/dashboard/payments", icon: CreditCard, label: "Pay", testid: "bottomnav-payments" });
  if (showPayments) items.push({ to: "/dashboard/pending", icon: Clock, label: "Pending", testid: "bottomnav-pending" });
  const cols = items.length + 1;
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="mobile-bottom-nav">
      <div className="grid" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))` }}>
        {items.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.testid}
            className="relative flex flex-col items-center gap-1 py-2.5">
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-pulse-green" />}
                <it.icon size={21} className={isActive ? "text-pulse-navy" : "text-slate"} />
                <span className={`text-[11px] font-medium ${isActive ? "text-pulse-navy" : "text-slate"}`}>{it.label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button onClick={onMore} data-testid="bottomnav-more" className="flex flex-col items-center gap-1 py-2.5">
          <Menu size={21} className="text-slate" />
          <span className="text-[11px] font-medium text-slate">More</span>
        </button>
      </div>
    </nav>
  );
}
